import React from "react";
import "./Testimonial.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import { Pagination } from "swiper";
import "swiper/css/pagination";
import profilePic1 from "../../img/profile1.jpg";
import profilePic2 from "../../img/profile2.jpg";
import profilePic3 from "../../img/profile3.jpg";
import profilePic4 from "../../img/profile4.jpg";

const Testimonial = () => {
  const clients = [
    {
      img: profilePic1,
      review:
        "Wods cannot express my gratitude for the work that you have done on our project. from the very beginning, it was evident that you truly understood our vision and were committed to making it to reality.",
    },
    {
      img: profilePic2,
      review:
        "I was particularly impressed with their strong communication skills. This level of transparency allowed us to build a strong working relationship, based on trust and effective collaboration.",
    },
    {
      img: profilePic3,
      review:
        "Wods cannot express my gratitude for the work that you have done on our project. from the very beginning, it was evident that you truly understood our vision and were committed to making it to reality.",
    },
    {
      img: profilePic4,
      review:
        "I was particularly impressed with their strong communication skills. This level of transparency allowed us to build a strong working relationship, based on trust and effective collaboration.",
    },
  ];

  return (
    <div className="t-wrapper" id="testimonial">
      <div className="t-heading">
        <span>Clients always get </span>
        <span>Exceptional Work </span>
        <span>from me...</span>
      <div className="blur t-blur1" style={{ background: "var(--purple)" }}></div>
      <div className="blur t-blur2" style={{ background: "skyblue" }}></div>

      </div>
      <Swiper
        // install Swiper modules
        modules={[Pagination]}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {clients.map((client, index) => {
          return (
            <SwiperSlide key={index}>
              <div className="testimonial">
                <img src={client.img} alt="" />
                <span>{client.review}</span>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default Testimonial;